import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CameraIcon, LightbulbIcon, LayoutIcon } from 'lucide-react';
export function ProductPresentation() {
  const benefits = [{
    icon: <LayoutIcon className="w-7 h-7 text-[#0284c7]" data-id="element-337" />,
    title: '+100 diseños exclusivos',
    desc: 'Catálogo completo de modelos probados y listos para fabricar.',
    image: 'https://images.unsplash.com/photo-1533090161767-e6ffed986c88?auto=format&fit=crop&q=80&w=800',
    colSpan: 'md:col-span-2'
  }, {
    icon: <CameraIcon className="w-7 h-7 text-[#0284c7]" data-id="element-338" />,
    title: 'Guía paso a paso',
    desc: 'Imágenes reales de cada etapa del proceso.',
    image: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?auto=format&fit=crop&q=80&w=800',
    colSpan: 'md:col-span-1'
  }, {
    icon: <LightbulbIcon className="w-7 h-7 text-[#0284c7]" data-id="element-339" />,
    title: 'Técnicas LED',
    desc: 'Secretos de iluminación para un efecto infinito perfecto.',
    image: 'https://images.unsplash.com/photo-1550751827-4bd374c3f58b?auto=format&fit=crop&q=80&w=800',
    colSpan: 'md:col-span-1'
  }, {
    icon: <BookOpenIcon className="w-7 h-7 text-[#0284c7]" data-id="element-340" />,
    title: 'Planos en alta resolución',
    desc: 'Medidas exactas y diagramas de conexión detallados.',
    image: 'https://images.unsplash.com/photo-1581092160562-40aa08e78837?auto=format&fit=crop&q=80&w=800',
    colSpan: 'md:col-span-2'
  }];
  return <section className="py-12 px-4 relative z-10 bg-slate-50 overflow-hidden" data-id="element-341">
      {/* Clean, bright atmosphere */}
      <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden" data-id="element-342">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-sky-100/40 rounded-full blur-[150px]" data-id="element-343" />
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-blue-50/50 rounded-full blur-[120px]" data-id="element-344" />
      </div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-345">
        <div className="text-center mb-20" data-id="element-346">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-sky-50 border border-sky-200 text-sky-700 text-sm font-bold mb-8 tracking-wide" data-id="element-347">
            <div className="w-2 h-2 rounded-full bg-sky-500" data-id="element-348" />
            LA SOLUCIÓN CLARA
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 tracking-tight leading-[1.1]" data-id="element-349">
            Todo lo que necesitás para{' '}
            <span className="text-[#0284c7]" data-id="element-350">empezar hoy</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-xl text-gray-600 max-w-2xl mx-auto font-normal leading-relaxed" data-id="element-351">
            El sistema completo diseñado para llevarte de cero a experto en
            tiempo récord.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-352">
          {benefits.map((benefit, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1,
          duration: 0.5
        }} className={`${benefit.colSpan} group relative bg-white rounded-[2.5rem] overflow-hidden border border-gray-100 shadow-sm hover:shadow-[0_30px_70px_rgba(2,132,199,0.12)] transition-all duration-500`} data-id="element-353">
              <div className="flex flex-col h-full" data-id="element-354">
                {/* Image Section */}
                <div className="relative h-64 md:h-72 overflow-hidden" data-id="element-355">
                  <img src={benefit.image} alt={benefit.title} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-110" data-id="element-356" />
                  <div className="absolute inset-0 bg-gradient-to-t from-white via-transparent to-transparent opacity-60" data-id="element-357" />

                  {/* Floating Icon Badge */}
                  <div className="absolute bottom-6 left-8 bg-white/90 backdrop-blur-md p-4 rounded-2xl shadow-lg border border-white/50 group-hover:scale-110 transition-transform duration-300" data-id="element-358">
                    {benefit.icon}
                  </div>
                </div>

                {/* Text Content */}
                <div className="p-8 md:p-10 pt-4" data-id="element-359">
                  <h3 className="text-2xl font-bold text-gray-900 mb-3 tracking-tight" data-id="element-360">
                    {benefit.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed text-lg" data-id="element-361">
                    {benefit.desc}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}